import ReactGA from "react-ga4";

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize("G-5319L4ES4W");
};

// Log custom events
export const logEvent = (eventName, params = {}) => {
  const userId = localStorage.getItem("user_id");

  ReactGA.event(eventName, {
    custom_user_id: userId,
    page_location: globalThis.location.href,
    page_path: globalThis.location.pathname,
    environment: globalThis.location.hostname === "localhost" ? "local" : "prod",
    ...params,
  });
};
